import ApiService from "@/services/apiservice";
import {
  LOGIN,
  LOGOUT,
  UPDATE_PARTNERNAME,
  SEND_NOTIFICATION_COUNT,
  RESET_PASSWORD
} from "./actions.type";
import {
  SET_AUTH,
  CLEAR_VUEX,
  SET_UPDATE_PARTNERNAME
} from "./mutations.type";
import {
  BehaviorSubject
} from "rxjs";
import _ from "lodash";
import {
  messaging
} from "../../src/connectFCM.js";
import store from "./index";
import {
  SEND_FCM_TOKEN
} from "./actions.type";
const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);

export const authenticationService = {
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  }
};

const getDefaultState = () => {
  return {
    errors: null,
    user: {},
    access_token: "",
    authenticated: false,
    permissions: [],
    roleName: "",
    partnerName: ""
  };
};

const state = getDefaultState();

const getters = {};

const actions = {
  async [LOGIN](context, payload) {
    try {
      let {
        data
      } = await ApiService.post("login", payload);
      let responceData = data;
      if (responceData.status) {
        if (messaging) {
          messaging
            .requestPermission()
            .then(function () {
              return messaging.getToken();
            })
            .then(function (token) {
              let fcm_payload = {
                device_token: token
              };
              store.dispatch(SEND_FCM_TOKEN, fcm_payload).then(result => {
                if (result.status) {
                  localStorage.setItem("device_token", payload.device_token);
                  store.dispatch(SEND_NOTIFICATION_COUNT);
                }
              });
            })
            .catch(function (error) {
              console.log("Error Per", error);
            });
        }
        localStorage.setItem("currentUser", JSON.stringify(responceData));
        localStorage.setItem("token", responceData.success.token);

        if (!_.get(data, "success.isfirstime", false)) {
          localStorage.setItem(
            "permission",
            JSON.stringify(responceData.success.role.permissions)
          );
          localStorage.setItem("userid", responceData.success.userid);
          localStorage.setItem("expires_in", Number(new Date().getTime() + (Number(responceData.success.expires_in) * 1000)));
          currentUserSubject.next(responceData);
          context.commit(SET_AUTH, responceData.success);
        }


      }
      return responceData;
    } catch (error) {
      return {
        state: false,
        message: "申し訳ありません、現在何らかの問題が発生しています。"
      };
    }
  },
  async [LOGOUT](context, payload) {
    if (localStorage.getItem("device_token")) {
      let data = {
        device_token: localStorage.getItem("device_token")
      };
      ApiService.get("logout", data);
    }

    // localStorage.removeItem("currentUser");
    localStorage.clear();
    currentUserSubject.next(null);
    context.commit(CLEAR_VUEX, false);
    return true;
  },
  [UPDATE_PARTNERNAME](context, payload) {
    context.commit(SET_UPDATE_PARTNERNAME, payload);
    return true;
  },
  async [RESET_PASSWORD](context, payload) {
    let {
      data
    } = await ApiService.post("reset", payload);
    if (_.get(data, "status", false)) {
      console.log(localStorage.getItem("currentUser"));
      let responceData = JSON.parse(localStorage.getItem("currentUser"))
      localStorage.setItem("token", responceData.success.token);
      localStorage.setItem(
        "permission",
        JSON.stringify(responceData.success.role.permissions)
      );
      localStorage.setItem("userid", responceData.success.userid);
      currentUserSubject.next(responceData);
      context.commit(SET_AUTH, responceData.success);
    }
    return data;
  },
};

const mutations = {
  [SET_AUTH](state, responce) {
    if (responce.token) {
      state.access_token = responce.token;
      state.authenticated = true;
      state.permissions = _.get(responce, "role.permissions", []);
      state.roleName = _.get(responce, "role.id", "");
      state.partnerName = _.get(responce, "partner.name", "");

      state.authenticated = responce;
    }
  },
  [CLEAR_VUEX](state, response) {
    Object.assign(state, getDefaultState());
  },
  [SET_UPDATE_PARTNERNAME](state, response) {
    state.partnerName = response;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};